import { TypographyOptions } from "@mui/material/styles/createTypography";
import { spacing } from "./spacing";

export const typographyComponents: TypographyOptions = {
    headingXL: {
        fontSize: "2.8rem",
        lineHeight: 1.1,
        fontFamily: "NNNittiGroteskHeading",
        marginBottom: spacing[5],
    },
    headingL: {
        fontSize: "2.4rem",
        lineHeight: 1.1,
        fontFamily: "NNNittiGroteskHeading",
        marginBottom: spacing[5],
    },
    headingM: {
        fontSize: "2rem",
        lineHeight: 1.1,
        fontFamily: "NNNittiGroteskHeading",
        marginBottom: spacing[5],
    },
    headingS: {
        fontSize: "1.6rem",
        lineHeight: 1.1,
        fontFamily: "NNNittiGroteskHeading",
        marginBottom: spacing[5],
    },
    headingXS: {
        fontSize: "1.4rem",
        lineHeight: 1.1,
        fontFamily: "NNNittiGroteskHeading",
        marginBottom: spacing[5],
    },
    bodyTextL: {
        fontSize: "2rem",
        lineHeight: 1.5,
        fontFamily: "NNNittiGroteskTextRegular",
    },
    bodyTextM: {
        fontSize: "1.6rem",
        lineHeight: 1.5,
        fontFamily: "NNNittiGroteskTextRegular",
    },
    bodyTextS: {
        fontSize: "1.4rem",
        lineHeight: 1.5,
        fontFamily: "NNNittiGroteskTextRegular",
    },
    bodyTextXS: {
        fontSize: "1.2rem",
        lineHeight: 1.5,
        fontFamily: "NNNittiGroteskTextRegular",
    },
    button: {
        fontFamily: "NNNittiGroteskTextRegular",
    },
};
